const today = new Date();

export const defaultConcordancePeriod: [Date, Date] = [
    new Date(new Date().setDate(today.getDate() - 31)),
    new Date(new Date().setDate(today.getDate() - 1)),
];
